

<template>
  <div class="home">

    <Navigation> </Navigation>

    <Meldungen> </Meldungen>


    <div class="mx-4 mt-6  sm:flex flex-wrap">

      <div class="sm:w-3/5 flex flex-col">

        <MapComponent class=""> </MapComponent>

      </div>

      <div class="flex flex-col sm:w-2/5">

        <WandernInfo class=""> </WandernInfo>

      </div>

    </div>

    <Cookie> </Cookie>

    <FooterVue> </FooterVue>

  </div>
</template>

<script>
// @ is an alias to /src
import MapComponent from '@/components/MapComponent.vue'
import WandernInfo from '@/components/WandernInfo.vue'
import Navigation from '@/components/Navigation.vue'
import FooterVue from '@/components/FooterVue.vue'
import Meldungen from '@/components/Meldungen.vue'
import Cookie from '@/components/Cookie.vue'

export default {
  name: 'home',

  components: {
    MapComponent,
    WandernInfo,
    Navigation,
    FooterVue,
    Meldungen,
    Cookie
  },

  methods: {

    onload: function () {
      this.$store.dispatch('initialfetch');
    },

  },
  mounted: function(){

    this.onload();

  },

  computed: {

  }

}
</script>

<style media="screen">

</style>
